import {
    Container, Grid, InputAdornment,MenuItem, InputLabel, Modal, Card, TextField, Box, FormControlLabel, Checkbox, Button, Typography, Input, FormControl,
    Select, AppBar, Toolbar
} from '@mui/material'
import React from 'react'
import { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AssignmentCreateForm() {
    const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(1);


    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    let navigate = useNavigate();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [teachersList, setTeacherList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedTeacherId, setSelectedTeacherId] = useState('');
    const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedSubjectId, setSelectedSubjectId] = useState('');
    const [sectionList, setSectionList] = useState([]);
    const [subjectList, setSubjectList] = useState([]);
    const [selectedSectionId, setSelectedSectionId] = useState('');
    const [assignmentDescription, setAssignmentDescription] = useState('');
    const [assignmentDate, setAssignmentDate] = useState('');
    const [submissionDate, setSubmissionDate] = useState('');
    const [assignmentFile, setAssignmentFile] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleFileChange = (event) => {
        setAssignmentFile(event.target.files[0]);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        // Ensure day and month are two digits
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedMonth = month < 10 ? '0' + month : month;

        return `${formattedDay}/${formattedMonth}/${year}`;
    };

    const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};

useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  if (isMasterUser) {
    fetchBranches();
  } else {
    const branchId = sessionStorage.getItem("branchId");
    setSelectedBranchId(branchId);
  }
}, []);

    const handleReset = () => {
        // Reset all state variables to their initial values
        setSelectedTeacherId('');
        setSelectedClassId('');
        setSelectedSectionId('');
        setSelectedSubjectId('');
        setAssignmentDescription('');
        setAssignmentDate('');
        setSubmissionDate('');
        setAssignmentFile(null);
        setSuccessMessage('');
        setErrorMessage('');
    };

    // Add this constant at the top of the component, after the imports or state declarations
const notificationUrl = "https://wsmsv1.aidigitalsec.com/api/Notifications/PostAssignmentNotification";

// Updated handleSubmit function
const handleSubmit = async (event) => {
  event.preventDefault();
  const formattedAssignmentDate = formatDate(assignmentDate);
  const formattedSubmissionDate = formatDate(submissionDate);

  const formData = new FormData();
  formData.append('ClassId', selectedClassId);
  formData.append('SectionId', selectedSectionId);
  formData.append('SubjectId', selectedSubjectId);
  formData.append('TeacherId', selectedTeacherId);
  formData.append('AssignmentDescription', assignmentDescription);
  formData.append('AssignmentDate', formattedAssignmentDate);
  formData.append('AssignmentSubmitDate', formattedSubmissionDate);
  formData.append('AssignmentFile', assignmentFile);
  const branchId = isMaster 
  ? selectedBranchId 
  : sessionStorage.getItem("branchId");


  try {
    const url = process.env.REACT_APP_BASE_URL;
    const apiUrl = `${url}/AssignmentCreate?Branch_Id=${branchId}`;
    const token = sessionStorage.getItem('token');
    const userId = parseInt(sessionStorage.getItem("userId")) || 0;
    const clientName = sessionStorage.getItem("clientName") || "";
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        Authorization: token,
      },
      body: formData,
    });

    if (response.ok) {
      // Send notification for the successfully created assignment
      const message = `${clientName} created assignment "${assignmentDescription.substring(0, 50)}${assignmentDescription.length > 50 ? '...' : ''}"`;
      const notifBody = {
        userId,
        message,
        name: clientName
      };

      await fetch(notificationUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(notifBody),
      }).catch((err) => {
        console.error("Notification API Error:", err);
      });

      // Handle successful response
      console.log('Assignment created successfully');
      // Clear form fields and show success message
      clearForm();
      setShowSuccessModal(true);
    } else {
      // Handle error response
      console.error('Failed to create assignment');
      setErrorMessage('Failed to create assignment');
      setSnackbarMessage('Failed to create assignment');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  } catch (error) {
    console.error('API request error:', error);
    setSnackbarMessage('API request error');
    setOpenSnackbar(true);
    setSnackbarSeverity("error");
  }
};


    const clearForm = () => {
        setSelectedClassId('');
        setSelectedSectionId('');
        setSelectedSubjectId('');
        setSelectedTeacherId('');
        setAssignmentDescription('');
        setAssignmentDate('');
        setSubmissionDate('');
        setAssignmentFile(null);
    };

   const fetchTeachers = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

    const response = await fetch(`${apiUrl}/AssignmentCreate/GetTeacher?Branch_Id=${branchId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ }),
    });

    if (!response.ok) {
      throw new Error(`Error fetching teachers: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      setTeacherList([]);
      return;
    }
    // Handle both array and object responses
    const teachers = Array.isArray(data) ? data : (data.data || []);
    setTeacherList(teachers);
  } catch (error) {
    console.error(error);
    setTeacherList([]);
  }
};

const fetchClasses = async (teacherId) => {
  try {
    // Reset dependent dropdowns when teacher changes
    setClassList([]);
    setSectionList([]);
    setSubjectList([]);
    setSelectedClassId('');
    setSelectedSectionId('');
    setSelectedSubjectId('');

    if (!teacherId) {
      return;
    }

    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

    const response = await fetch(`${apiUrl}/AssignmentCreate/GetClass?Branch_Id=${branchId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ teacherId}),
    });

    if (!response.ok) {
      throw new Error(`Error fetching classes: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      setClassList([]);
      return;
    }
    // Handle both array and object responses
    const classes = Array.isArray(data) ? data : (data.data || []);
    setClassList(classes);
  } catch (error) {
    console.error(error);
    setClassList([]);
  }
};

const fetchSections = async (classId, teacherId) => {
  try {
    // Reset dependent dropdowns
    setSectionList([]);
    setSubjectList([]);
    setSelectedSectionId('');
    setSelectedSubjectId('');

    if (!classId || !teacherId) {
      return;
    }

    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

    const response = await fetch(`${apiUrl}/AssignmentCreate/ddlSection_clsId?Branch_Id=${branchId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ classId, teacherId }),
    });

    if (!response.ok) {
      throw new Error(`Error fetching sections: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      setSectionList([]);
      return;
    }
    // Handle both array and object responses
    const sections = Array.isArray(data) ? data : (data.data || []);
    setSectionList(sections);
  } catch (error) {
    console.error(error);
    setSectionList([]);
  }
};

const fetchSubject = async (classId, teacherId, sectionId) => {
  try {
    // Reset subject dropdown
    setSubjectList([]);
    setSelectedSubjectId('');

    if (!classId || !teacherId || !sectionId) {
      return;
    }

    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

    const response = await fetch(`${apiUrl}/AssignmentCreate/Subjectddl?Branch_Id=${branchId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ classId, teacherId, sectionId }),
    });

    if (!response.ok) {
      throw new Error(`Error fetching subjects: ${response.status}`);
    }
    const data = await response.json();
    if (data.data === null && data.msg === "Record Not Found") {
      setSubjectList([]);
      return;
    }
    // Handle both array and object responses
    const subjects = Array.isArray(data) ? data : (data.data || []);
    setSubjectList(subjects);
  } catch (error) {
    console.error(error);
    setSubjectList([]);
  }
};

useEffect(() => {
  if (selectedBranchId) {
    fetchTeachers();
  }
}, [selectedBranchId]);


    useEffect(() => {
        fetchTeachers();
    }, []);

    useEffect(() => {
        fetchClasses(selectedTeacherId);
    }, [selectedTeacherId]);

    useEffect(() => {
        fetchSections(selectedClassId, selectedTeacherId);
    }, [selectedClassId, selectedTeacherId]);

    useEffect(() => {
        fetchSubject(selectedClassId, selectedTeacherId, selectedSectionId);
    }, [selectedClassId, selectedTeacherId, selectedSectionId]);

    useEffect(() => {
        const today = new Date();
        const sevenDaysLater = new Date();
        sevenDaysLater.setDate(today.getDate() + 7);

        const formatToInputDate = (date) => {
            const year = date.getFullYear();
            const month = (`0${date.getMonth() + 1}`).slice(-2);
            const day = (`0${date.getDate()}`).slice(-2);
            return `${year}-${month}-${day}`;
        };

        setAssignmentDate(formatToInputDate(today));
        setSubmissionDate(formatToInputDate(sevenDaysLater));
    }, []);

    useEffect(() => {
        if (!assignmentDate) return;

        const assignment = new Date(assignmentDate);
        assignment.setDate(assignment.getDate() + 7);

        const formatToInputDate = (date) => {
            const year = date.getFullYear();
            const month = (`0${date.getMonth() + 1}`).slice(-2);
            const day = (`0${date.getDate()}`).slice(-2);
            return `${year}-${month}-${day}`;
        };

        setSubmissionDate(formatToInputDate(assignment));
    }, [assignmentDate]);

    return (
        <Container>
             <AppBar
  position="static"
  sx={{
    backgroundColor: "#0B1F3D",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
  }}
>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
    
    {/* Left: Title */}
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        letterSpacing: "0.5px",
        color: "#ffffff",
      }}
    >
     Create Assignment
    </Typography>

    {/* Right: Branch Dropdown */}
   {isMaster && (
  <Box sx={{ position: "relative" }}>
    <FormControl size="small" sx={{ width: 220 }}>
      <InputLabel
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "0.75rem",
          fontWeight: 500,
          letterSpacing: "0.6px",
          textTransform: "uppercase",
          top: "-2px",
          "&.Mui-focused": { color: "#64B5F6" },
          "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
        }}
      >
        Branch
      </InputLabel>
      <Select
        value={selectedBranchId || ""}
        onChange={(e) => setSelectedBranchId(e.target.value)}
        label="Branch"
        startAdornment={
          <InputAdornment position="start">
            <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
          </InputAdornment>
        }
        sx={{
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "0.875rem",
          letterSpacing: "0.3px",
          backgroundColor: "rgba(255,255,255,0.07)",
          backdropFilter: "blur(8px)",
          borderRadius: "8px",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.15)",
            borderWidth: "1px",
            transition: "border-color 0.2s ease",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.11)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.35)",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(255,255,255,0.1)",
            boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#64B5F6",
              borderWidth: "1.5px",
            },
          },
          "& .MuiSelect-icon": {
            color: "rgba(255,255,255,0.5)",
            transition: "color 0.2s ease",
          },
          "&.Mui-focused .MuiSelect-icon": {
            color: "#64B5F6",
          },
          "& .MuiSelect-select": {
            py: 1.1,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              borderRadius: "10px",
              border: "1px solid rgba(11,31,61,0.12)",
              boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              "& .MuiList-root": { py: 0.5 },
            },
          },
        }}
      >
        {branches.map((branch) => (
          <MenuItem
            key={branch.branchId}
            value={branch.branchId}
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#0B1F3D",
              px: 2,
              py: 1.1,
              mx: 0.5,
              borderRadius: "6px",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "rgba(11,31,61,0.07)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(25,118,210,0.1)",
                color: "#1565C0",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(25,118,210,0.15)",
                },
              },
            }}  
          >
            {branch.branchName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
)}
  </Toolbar>
</AppBar>

            <Card className="card-body" style={{ marginTop: 6 }}>
                <Box
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Container className="mt-3">
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item md={6} >
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="teacher" required>Teacher</InputLabel>
                                        <Select
                                            labelId="teacher-label"
                                            id="teacher-select"
                                            label="Teacher"
                                            value={selectedTeacherId}
                                            onChange={(e) => setSelectedTeacherId(e.target.value)}
                                        >
                                            {/* Populate with teacher options */}
                                            {Array.isArray(teachersList) && teachersList.map((item) => (
                                                <MenuItem key={item.employeeId} value={item.employeeId}>
                                                    {item.employeeName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginTop: "15px" }}>
                                        <InputLabel htmlFor="section" required>Section</InputLabel>
                                        <Select
                                            labelId="section-label"
                                            id="section-select"
                                            value={selectedSectionId}
                                            onChange={(e) => setSelectedSectionId(e.target.value)}
                                            label="Section"
                                        >
                                            {/* Populate with section options */}
                                            {Array.isArray(sectionList) && sectionList.length > 0 ? (
                                                sectionList.map((sectionItem) => (
                                                    <MenuItem key={sectionItem.sectionId} value={sectionItem.sectionId}>
                                                        {sectionItem.sectionName}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem value="">No sections found</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginTop: "15px" }}>
                                        <InputLabel htmlFor="subject" required>Subject</InputLabel>
                                        <Select
                                            labelId="subject-label"
                                            id="subject-select"
                                            label="Subject"
                                            value={selectedSubjectId}
                                            onChange={(e) => setSelectedSubjectId(e.target.value)}
                                        >
                                            {Array.isArray(subjectList) && subjectList.map((item) => (
                                                <MenuItem key={item.subjectId} value={item.subjectId}>
                                                    {item.subjectName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item md={6}>
                                    <FormControl fullWidth >
                                        <InputLabel htmlFor="Class">Class</InputLabel>
                                        <Select
                                            labelId="class-label"
                                            id="class-select"
                                            value={selectedClassId}
                                            onChange={(e) => setSelectedClassId(e.target.value)}
                                            label="Class"
                                        >
                                            {/* Populate with class options */}
                                            {Array.isArray(classList) && classList.map((classItem) => (
                                                <MenuItem key={classItem.classId} value={classItem.classId}>
                                                    {classItem.className}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        id="assignment-description"
                                        label="Assignment Description"
                                        multiline
                                        rows={3}
                                        fullWidth
                                        style={{ marginTop: "15px" }}
                                        value={assignmentDescription}
                                        onChange={(e) => setAssignmentDescription(e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={6} >
                                    <TextField
                                        id="assignment-date"
                                        label="Assignment Date"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={assignmentDate}
                                        onChange={(e) => setAssignmentDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item md={6} style={{ marginTop: "1px" }} >
                                    <TextField
                                        id="submission-date"
                                        label="Submission Date"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={submissionDate}
                                        onChange={(e) => setSubmissionDate(e.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3} mt={2}>
                                <Grid item xs={6}>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Upload Assignment
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item>
                                <form>
                                    <Box className="form-group">
                                        <Typography variant="subtitle1" gutterBottom></Typography>
                                        <Input type="file" onChange={handleFileChange} />
                                    </Box>
                                </form>
                            </Grid>
                        </form>
                    </Container>
                </Box>

            </Card>
            <Grid
                container
                justifyContent="end"
                alignItems="center"
            >
                <Button variant="contained" type="submit" onClick={handleSubmit}
                    color="primary"
                    style={{
                        width: "90px",
                        height: "50px",
                        padding: "10px 0",
                        fontWeight: 'bold',
                        marginTop: 16,
                        marginRight: 7
                    }}
                >
                    SAVE
                </Button>
                <Button variant="contained" type="submit" onClick={handleReset}
                    color="error"
                    style={{
                        width: "90px",
                        height: "50px",
                        padding: "10px 0",
                        fontWeight: 'bold',
                        marginTop: 16
                    }}
                >
                    RESET
                </Button>
            </Grid>

            <Modal
                open={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                aria-labelledby="success-modal-title"
                aria-describedby="success-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        overflow: 'hidden',
                    }}
                >
                    {/* Header */}
                    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                        <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
                            Assignment Created ✅
                        </Typography>
                    </Box>

                    {/* Content */}
                    <Box sx={{ padding: '20px' }}>
                        <Typography id="success-modal-description" sx={{ mb: 2 }}>
                            The Assignment has been created successfully.
                        </Typography>

                        {/* Buttons */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                            <Button
                                onClick={() => {
                                    setShowSuccessModal(false);
                                    navigate(-1); // go back after closing modal
                                }}
                                variant="contained"
                                color="primary"
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

        </Container>
    );

}

export default AssignmentCreateForm;